
import BaseLayoutValue from './BaseLayoutValue';
import { ExpansionTemplateInfo } from './Contexts';

import { useContext } from 'react';

export default function FigureImageExpansionLayout({nodeId, nodes,
  style, 
  regions,
  parentPixelDimensions,
  computedDimensions,
}){

  //let computedDimensions = useContext(ExpansionTemplateInfo);

  
  let node = nodes[nodeId];

  if( !node ){
    debugger;
  }

  

  let { d, c, value } = node || {};
  let parentStyle = node.style || {};

 
  let nodeDims = computedDimensions?.[nodeId] || { w:1, h: 1};
  nodeDims = { ...nodeDims };

  if( !parentPixelDimensions ){
  }

  let nodeWidth = parentPixelDimensions.w * (nodeDims.w);// * 100 + '%';
  let nodeHeight = (parentPixelDimensions.h??parentPixelDimensions.w) * (nodeDims.h);// * 100 + '%';


  //console.log(JSON.stringify({ nodeId, nodeWidth, nodeHeight }));


  let thisPixelDimensions = {
    w:nodeWidth,
    h:nodeHeight
  }

  

  return (
    <div 
      onClick={() => {
      }}
      valueType={"crop-expansion"}

      class={"" +(d === "h" ? "sg-row" : "sg-col") } style={{

      width:nodeDims.w,//nodeWidth,
      height:nodeDims.h,//nodeHeight,


      //border:(c ? '2px solid red' : '2px solid blue'),
      position:'relative',
    }}>
      {value && <BaseLayoutValue {...{
          value,
        regions,
        node,
        nodeId,
        nodes,
        parentPixelDimensions:thisPixelDimensions,
        computedDimensions,
        
      }}/>
      }

      {!value && (c||[]).map(listItem => {
        return(
          <FigureImageExpansionLayout 
            key={listItem}
            nodeId={listItem}
          nodes={nodes}
            regions={regions}
          computedDimensions={computedDimensions}
          parentPixelDimensions={thisPixelDimensions}
          />
        )
      })}



      




    </div>
  )



}
